/* Running Shoes House - coloris sur les vignettes du catalogue.
   Chaque coloris est un produit separe (ex. NB 2002R Khaki Green, Black,
   Brown...). On regroupe les produits d'un meme modele par prefixe de handle,
   exactement comme la fiche produit, et on affiche les vignettes de coloris
   sous chaque carte avec le nombre TOTAL de coloris.
   Le cache sessionStorage est partage avec pdp-colors.js : une seule requete
   par session de navigation. */
(function () {
  'use strict';

  var boxes = document.querySelectorAll('[data-rp-colors]');
  if (!boxes.length || !window.fetch) return;

  var MAX_THUMBS = 6;

  var LEX = ('black white grey gray green blue red pink orange yellow purple violet navy cream beige brown khaki ' +
    'light dark silver gold ivory olive teal mint sand storm glacier tide tundra bone flax onyx resin azure marsh ' +
    'dew frost pearl wolf alloy cinder eclipse seedling limelight truffle nebula ghost tin twilight rock brook ' +
    'iceberg nimbus winter kasha graphite ink salmon cyan lime coral aqua crimson volt anthracite mushroom sail ' +
    'smoke smokey oatmeal oatmilk gypsum summit particle guava sunset seaweed cannon foam hero pulse caldera ' +
    'reverse swoosh barely metallic sky sea espresso safari midnight gobi seashell flint honeydew asphalt pelican ' +
    'dust sienna thistle horizon peony foxglove dijon pebble oyster camellia sunstone aquamarine platinum myrtle ' +
    'squash cascade sailor linen heather stone lilac mauve gardenia lily cobalt tangerine juniper magnet ray ' +
    'verdite apollo flurry tomato walnut castleroc rosemary bark charcoal chalk scarlet lemon').split(' ');

  var CACHE_KEY = 'rp_pdp_colors_v1';

  function titleCase(handle) {
    return handle.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function buildGroups(products) {
    var colourWord = {};
    LEX.forEach(function (w) { colourWord[w] = 1; });

    function hasColourOption(p) {
      return (p.options || []).some(function (o) { return /couleur|color/i.test(o.name || ''); });
    }

    products.forEach(function (p) {
      if (!hasColourOption(p)) return;
      (p.options || []).forEach(function (o) {
        if (!/couleur|color/i.test(o.name || '')) return;
        (o.values || []).forEach(function (v) {
          String(v).toLowerCase().split(/[^a-z0-9]+/).forEach(function (t) { if (t) colourWord[t] = 1; });
        });
      });
    });

    var pool = products.filter(function (p) { return !hasColourOption(p); });

    var prefixCount = {};
    pool.forEach(function (p) {
      var seg = p.handle.split('-');
      for (var n = 2; n < seg.length; n++) {
        var pre = seg.slice(0, n).join('-');
        prefixCount[pre] = (prefixCount[pre] || 0) + 1;
      }
    });

    var baseOf = {};
    pool.forEach(function (p) {
      var seg = p.handle.split('-');
      var base = null;
      for (var n = seg.length - 1; n >= 2; n--) {
        var pre = seg.slice(0, n).join('-');
        if (prefixCount[pre] >= 2) { base = pre; break; }
      }
      baseOf[p.handle] = base;
    });

    var known = {};
    Object.keys(baseOf).forEach(function (h) { if (baseOf[h]) known[baseOf[h]] = 1; });

    function collapse(base) {
      if (!base) return base;
      var seg = base.split('-');
      while (seg.length > 2 && colourWord[seg[seg.length - 1]]) {
        var parent = seg.slice(0, -1).join('-');
        if (known[parent]) seg.pop(); else break;
      }
      return seg.join('-');
    }

    var groups = {};
    pool.forEach(function (p) {
      var base = baseOf[p.handle];
      if (!base) return;
      var key = collapse(base);
      var image = (p.images && p.images[0] && p.images[0].src) || '';
      image = image.split('?')[0];
      var colour = p.title.replace(new RegExp('^' + escapeRe(titleCase(key)), 'i'), '').replace(/^[\s\-–—'"]+/, '').trim();
      (groups[key] = groups[key] || []).push({ handle: p.handle, image: image, colour: colour || p.title });
    });

    var out = {};
    Object.keys(groups).forEach(function (k) { if (groups[k].length >= 2) out[k] = groups[k]; });
    return out;
  }

  function loadGroups(done) {
    try {
      var cached = window.sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && Object.keys(parsed).length) { done(parsed); return; }
      }
    } catch (e) {}

    var all = [];
    var page = 1;

    function step() {
      window.fetch('/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.products && d.products.length) {
            all = all.concat(d.products);
            page++;
            if (page <= 5 && d.products.length === 250) step(); else finish();
          } else finish();
        })
        .catch(finish);
    }

    function finish() {
      var groups = buildGroups(all);
      try {
        if (groups && Object.keys(groups).length) {
          window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(groups));
        }
      } catch (e) {}
      done(groups);
    }

    step();
  }

  function sizeUrl(src, width) {
    if (!src) return src;
    return src.replace(/(\.(?:jpg|jpeg|png|webp))(?=$|\?)/i, '_' + width + 'x$1');
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  loadGroups(function (groups) {
    var byHandle = {};
    Object.keys(groups).forEach(function (k) {
      groups[k].forEach(function (m) { byHandle[m.handle] = groups[k]; });
    });

    var preview = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
    var query = preview ? '?preview_theme_id=' + preview[1] : '';

    Array.prototype.forEach.call(boxes, function (box) {
      var handle = box.getAttribute('data-handle');
      var members = byHandle[handle];
      if (!members || members.length < 2) return;

      // Le coloris affiche sur la carte passe en premier.
      var ordered = members.slice().sort(function (a, b) {
        if (a.handle === handle) return -1;
        if (b.handle === handle) return 1;
        return 0;
      });

      var list = box.querySelector('[data-rp-colors-list]');
      var more = box.querySelector('[data-rp-colors-more]');
      if (!list) return;

      var html = '';
      ordered.slice(0, MAX_THUMBS).forEach(function (m) {
        var active = m.handle === handle ? ' is-current' : '';
        var label = esc(m.colour);
        html += '<a class="ccard__color' + active + '" href="/products/' + m.handle + query +
          '" title="' + label + '" aria-label="' + label + '">' +
          '<img src="' + sizeUrl(m.image, 160) + '" alt="' + label + '" width="160" height="160" loading="lazy"></a>';
      });
      list.innerHTML = html;

      // Total de coloris : reste juste quel que soit le nombre de pastilles
      // reellement visibles a l'ecran.
      if (more) more.textContent = ordered.length + ' colors';

      box.hidden = false;
    });
  });
})();
